export const ORGANIZATION_ROLES_DESCRIPTIONS = {
  ADMIN: "Admin",
  CLIENT: "Client",
  NONE: "None"
};

export const CONTACT_US = "Contact labsupport@demystdata.com for more information";

export const alphabet = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
];

export const NON_FILTER_QUERY_PARAMS = {
  PRODUCT_DETAILS: "product_details"
};

export const FILTER_TYPES = {
  INPUT_TYPES: "input_types",
  REGIONS: "regions",
  SELECTED_CATEGORIES: "selected_categories",
  ONLINE_PRODUCTS: "online_products",
  INSTANT_APPEND: "instant_append",
  ORG_APPROVED: "org_approved",
  FCRA_PERMISSIBLE: "fcra_permissible"
};

export const FILTER_ALIASES = {
  [FILTER_TYPES.ONLINE_PRODUCTS]: "Online Products",
  [FILTER_TYPES.INSTANT_APPEND]: "Instant Append",
  [FILTER_TYPES.ORG_APPROVED]: "Org Approved",
  [FILTER_TYPES.FCRA_PERMISSIBLE]: "FCRA Permissible"
};

export const INCLUDE_INPUT_OVERRIDE_VALUES = {
  ALWAYS_INCLUDE_INPUTS: "ALWAYS_INCLUDE_INPUTS",
  NEVER_INCLUDE_INPUTS: "NEVER_INCLUDE_INPUTS"
};

export const BATCH_STATES = {
  DRAFT: "draft",
  PENDING_APPROVAL: "pending_approval",
  PAUSED: "paused",
  RUNNING: "running",
  COMPLETE: "complete",
  UPLOADING: "uploading",
  UPLOADED: "uploaded",
  PREPROCESSING: "preprocessing"
};

export const EXAMPLE_CHANNEL_CONFIGURATION_TO_USE_AS_TEXTAREA_PLACEHOLDER = `{
  "config": {
    "mode": "live"
  },
  "providers": {
    "equifax_austin_tetra_discovery": {
      "timeout": 1,
      "version": "$latest"
    },
    "hosted_equifax_mds": {
      "version": 24,
      "input": {
        "efx_id": "equifax_austin_tetra_discovery.discovery[0].efx_id"
      }
    }
  },

  "refine": {
    "efx_id": "equifax_austin_tetra_discovery.discovery[0].efx_id",
    "contact": "hosted_equifax_mds.results[0].efx_contct",
    "sic_code": {
      "$firstOf": [
        "everstring_company_enrichment.data[0].es_sic_4",
        "hosted_equifax_mds.results[0].efx_primsic"
      ]
    }
  }
}`;
